import { useEffect, useState } from "react";
import { SimplifiedUserProduct } from "../../Models/Product";
import { productService } from "../../Api/Services/productService";
import ProductListCard from "../ProductListCard/ProductListCard";

type ProductListProps = {
  search: string;
};

const ProductList: React.FC<ProductListProps> = ({ search }) => {
  const [products, setProducts] = useState<SimplifiedUserProduct[]>([]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!search) {
        setProducts([]);
        return;
      }

      const data = await productService.getAllActive({
        page: 1,
        pageSize: 4,
        search 
      });
      
      setProducts(data.items);
    };

    if (search) {
      fetchProducts();
    }
  }, [search]);

  return (
    <div>
      {products.map(product => (
        <ProductListCard
          key={product.id}
          id={product.id}
          image={product.mainImageUrl}
          name={product.name}
          code={product.code}
          price={product.price}
        />
      ))}
    </div>
  )
}

export default ProductList
